import { Link } from 'react-router-dom';

var React = require('react');
var Masonry = require('react-masonry-component');


var masonryOptions = {
    transitionDuration: 500,
    gutter: 10,
    itemSelector: '.GalleryItemContainer'
};

class Gallery extends React.Component {
    render () {
        var childElements = this.props.elements.map(function(element){
           return (
                <div key={element.id} className="GalleryItemContainer">
                    <img className="GalleryItem" src={element.src} width={element.size} height={element.size} />
                </div>
            );
        });

        return (
            <Masonry
                className="Gallery" 
                elementType={'div'} // default 'div'
                options={masonryOptions} // default {}
                disableImagesLoaded={false} // default false
                updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
            >
                {childElements}
            </Masonry>
        );
    }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/gallery.js